import React from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import { selectAuth } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import FreshLeadStructure from "../../components/lead-management/fresh-lead/FreshLeadStructure";

const FreshLeads = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return (
    <HelmetWrapper title="WTF: Lead Management System">
      <Container className="bg-cloud-k px-50px" fluid>
        <FreshLeadStructure userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default FreshLeads;